import { useRef } from "preact/hooks";
import UseEffectOptions from "./UseEffectOptions";
import useEffectWithOptions from "./useEffectWithOptions";

export default function useResize(element: Element | undefined, effect: () => void, options?: UseEffectOptions) {
    const resizeObserverRef = useRef<ResizeObserver>(null);

    useEffectWithOptions(() => {
        resizeObserverRef.current?.disconnect();

        resizeObserverRef.current = new ResizeObserver(effect);
        if (element) {
            resizeObserverRef.current.observe(element);
        }

        return () => resizeObserverRef.current?.disconnect();
    }, [element], options);
}
